<template>
    <div id="statement_header">
        <h1 class="title">{{ title }}</h1>
    </div>
</template>
<script>
export default {
    props : {
        title : {
            type : String
        }
    }
}

</script>

<style lang="scss">
    #statement_header{
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 65px;
        background-color: #02F0E4;
        color: #fff;
        padding: 0 25px;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 1px;

        .title{
            font-size: 20px;
        }
    }
    @media screen and (max-width: 400px){
        #statement_header{
            font-size: 19px;
        }
    }    
</style>
